import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Wings: the Details list on the product page. Lettered listings keep each piece's own lines
 * on its button (variant field wings.details); when the shopper picks another button, the list
 * is re-rendered from the section HTML, the same way as the line under the price.
 */
class WingsVariantLines extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section, dialog')?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  #onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;
        const next = detail.html.querySelector(`wings-variant-lines[data-block-id="${this.dataset.blockId}"]`);
        // A button with no lines of its own (and no product lines) renders no list: clear the old one.
        if (next) morph(this, next, { childrenOnly: true });
        else this.replaceChildren();
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[wings-variant-lines]', error);
      });
  };
}

if (!customElements.get('wings-variant-lines')) customElements.define('wings-variant-lines', WingsVariantLines);
